import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { signUpSchema } from "../Schema/index";
import { withRouter, useParams } from "react-router-dom";

const initialValues = {
  customerName: "",
  firmName: "",
  gstNo: "",
  panNo: "",
  inputEmail: "",
  mobileNo: "",
  alterMobNo: "",
  typeOfEnquiry: "",
  preBalance: "",
  liftTravel: "",
  // liftPreBal: "",
  // liftAmcBal:"",
  // liftModBal:"",
  address: "",
  exampleFormControlTextarea1: "",
  landmark: "",
};

function UpdateCustomer() {
  const { id } = useParams();
  // console.log("props",props.match?.params?.id);
  const [data, setData] = useState([]);
  const [customerName, setCustomerName] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [firmName, setFirmName] = useState("");
  const [gstNo, setGstNo] = useState("");
  const [panNo, setPanNo] = useState("");
  const [inputEmail, setInputEmail] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [alterMobNo, setAlterMobNo] = useState("");
  const [typeOfEnquiry, setTypeOfEnquiry] = useState("");
  const [preBalance, setPreBalance] = useState("");
  const [liftTravel, setLiftTravel] = useState("");
  const [exampleFormControlTextarea1, setAddress] = useState("");
  const [uniqueId, setUniqueId] = useState("");
  const [landmark, setLandmark] = useState("");
  // const [liftPreBal, setLiftPreBal] = useState(0);
  // const [amcPreBal, setAmcPreBal] = useState(0);
  // const [modPreBal, setModPreBal] = useState(0);

  const navigate = useNavigate();
  const [Avatar, setAvatar] = useState(
    "data:image/jpeg;base64,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",
  );

  const handleCustomerUniqueId = (event) => {
    // console.log("On Change");

    setUniqueId(event.target.value);
  };

  const handleCustomerName = (event) => {
    setCustomerName(event.target.value);
  };

  const handleFirmName = (event) => {
    setFirmName(event.target.value);
  };

  const handleGst = (event) => {
    setGstNo(event.target.value);
  };

  const handlePanNo = (event) => {
    setPanNo(event.target.value);
  };

  const handleEmail = (event) => {
    setInputEmail(event.target.value);
  };

  const handleMobileNo = (event) => {
    setMobileNo(event.target.value);
  };

  const handleAlMob = (event) => {
    setAlterMobNo(event.target.value);
  };

  const handleTypeOfEnquiry = (event) => {
    setTypeOfEnquiry(event.target.value);
  };

  const handleLiftTravel = (event) => {
    setLiftTravel(event.target.value);
  };

  const handleAddress = (event) => {
    setAddress(event.target.value);
  };

  // const handleLiftPreBal = (event)=>{
  //   // console.log("On Change");
  //   setLiftPreBal(event.target.value);
  // }

  // const handleAmcPreBal = (event)=>{
  //   // console.log("On Change");
  //   setAmcPreBal(event.target.value);
  // }

  // const handleModPreBal = (event)=>{
  //   // console.log("On Change");
  //   setModPreBal(event.target.value);
  // }

  const handleInvoiceDate = (event) => {
    setInvoiceDate(event.target.value);
  };

  const handleLandmark = (event) => {
    setLandmark(event.target.value);
    handleChange(event);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(
          `https://liftapp.infysky.in/liftapp_api/api/get_customer/${id}`,
        );
        const result = await response.json();
        console.log("data:", result);
        setData(result);
        setUniqueId(result.cu_unique_id);
        setCustomerName(result.cu_name);
        setFirmName(result.cu_firm);
        setGstNo(result.cu_gst);
        setPanNo(result.cu_pan);
        setInputEmail(result.cu_email);
        setMobileNo(result.cu_mobile);
        setAlterMobNo(result.cu_al_mobile);
        setTypeOfEnquiry(result.cu_lift_type);
        setLiftTravel(result.cu_lift_travel);
        setAddress(result.cu_address);
        setLandmark(result.cu_landmark);
        // setLiftPreBal (result.cu_lift_pre_bal)
        // setAmcPreBal (result.cu_amc_pre_bal)
        // setModPreBal (result.cu_mod_pre_bal)
        setInvoiceDate(result.cu_date);
      } catch (error) {
        console.error("Error", error);
      }
    }

    fetchData();
  }, [id]);

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      onSubmit: (values, action) => {
        console.log("values:", values);
        // await editProduct();
        action.resetForm();
        navigate("/app/customer");
      },
    });
  console.log(errors);

  const handleCustomChange = (event) => {
    handleCustomerName(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  const handleCustomChange1 = (event) => {
    handleFirmName(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  const handleCustomChange2 = (event) => {
    handleGst(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  const handleCustomChange3 = (event) => {
    handlePanNo(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  const handleCustomChange4 = (event) => {
    handleEmail(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  const handleCustomChange5 = (event) => {
    handleMobileNo(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  const handleCustomChange6 = (event) => {
    handleAlMob(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  const handleCustomChange7 = (event) => {
    handleTypeOfEnquiry(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  const handleCustomChange9 = (event) => {
    handleLiftTravel(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  const handleCustomChange10 = (event) => {
    handleAddress(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  // const handleCustomChange13 = (event) => {

  //   handleAmcPreBal(event); // Call the second custom onChange function
  //   handleChange(event); // Call the useFormik handleChange function
  // };

  // const handleCustomChange12 = (event) => {

  //   handleLiftPreBal(event); // Call the second custom onChange function
  //   handleChange(event); // Call the useFormik handleChange function
  // };

  // const handleCustomChange14 = (event) => {

  //   handleModPreBal(event); // Call the second custom onChange function
  //   handleChange(event); // Call the useFormik handleChange function
  // };

  const handleCustomChange15 = (event) => {
    handleCustomerUniqueId(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  const handleCustomChange16 = (event) => {
    handleInvoiceDate(event); // Call the second custom onChange function
    handleChange(event); // Call the useFormik handleChange function
  };

  async function editProduct(id) {
    const formData = new FormData();
    formData.append("uniqueId", uniqueId);
    formData.append("invoiceDate", invoiceDate);
    formData.append("customerName1", customerName);
    formData.append("firmName", firmName);
    formData.append("panNo", panNo);
    formData.append("gstNo", gstNo);
    formData.append("inputEmail", inputEmail);
    formData.append("mobileNo", mobileNo);
    formData.append("alterMobNo", alterMobNo);
    formData.append("typeOfEnquiry", typeOfEnquiry);
    formData.append("liftTravel", liftTravel);
    formData.append("landmark", landmark);
    // formData.append("amcPreBal",amcPreBal)
    // formData.append("modPreBal",modPreBal)
    // formData.append("img",Avatar)
    formData.append("exampleFormControlTextarea1", exampleFormControlTextarea1);

    try {
      let response = await fetch(
        "https://liftapp.infysky.in/liftapp_api/api/customer_update/" +
          id +
          "?method=PUT",
        {
          method: "POST",
          body: formData,
        },
      );

      let data1 = await response.json(); // Parse the response body as JSON

      if (data1.message) {
        // If the response status is within the 2xx range, it means the request was successful.
        alert(data1.message);
      } else {
        alert("An error occurred while saving the data.");
      }
    } catch (error) {
      console.error("Error while adding customer:", error);
      alert("An error occurred while saving the data2.");
    }
  }

  return (
    <div className="container">
      <form onSubmit={handleSubmit}>
        <div className="row mb-1">
          <div className="col-md-6">
            <div className="row mb-1">
              <div className="col-md-6">
                <div className="form-group">
                  <label
                    htmlFor="customerName"
                    className=""
                    style={{ fontSize: "14px" }}
                  >
                    {" "}
                    Customer Name:*
                  </label>
                  <input
                    type="text"
                    name="customerName"
                    defaultValue={data.cu_name}
                    className="form-control a1"
                    id="customerName"
                    // value={values.customerName}
                    onChange={handleCustomChange}
                    onBlur={handleBlur}
                  />
                </div>
              </div>
              {/* <div className="col-3 ">
                <div className="form-group">
                  <label htmlFor="uniqueId" className='' style={{ fontSize: '14px' }}>Job Id</label>
                  <input type="text" name="uniqueId" defaultValue={data.cu_unique_id} className="form-control a1" id="uniqueId"
                    // value={uniqueId}
                    onChange={handleCustomChange15}
                    onBlur={handleBlur}
                  />
                </div>
              </div> */}

              <div className="col-md-6 ">
                <div className="form-group">
                  <label
                    htmlFor="invoiceDate"
                    className=""
                    style={{ fontSize: "14px" }}
                  >
                    Date:
                  </label>
                  <input
                    type="date"
                    name="invoiceDate"
                    defaultValue={data.cu_date}
                    className="form-control a1"
                    id="invoiceDate"
                    //  value={values.invoiceDate}
                    onChange={handleCustomChange16}
                    onBlur={handleBlur}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-md-6 ">
                <div className="form-group">
                  <label
                    htmlFor="gstNo"
                    className=""
                    style={{ fontSize: "14px" }}
                  >
                    GST No.
                  </label>
                  <input
                    type="text"
                    name="gstNo"
                    defaultValue={data.cu_gst}
                    className="form-control a1"
                    id="gstNo"
                    // value={values.gstNo}
                    onChange={handleCustomChange2}
                    onBlur={handleBlur}
                  />
                </div>
              </div>
              <div className="col-md-6 ">
                <div className="form-group">
                  <label
                    htmlFor="panNo"
                    className=""
                    style={{ fontSize: "14px" }}
                  >
                    PAN No.
                  </label>
                  <input
                    type="text"
                    name="panNo"
                    defaultValue={data.cu_pan}
                    className="form-control a1"
                    id="panNo"
                    // value={values.panNo}
                    onChange={handleCustomChange3}
                    onBlur={handleBlur}
                  />

                  {/* {touched.panNo && errors.panNo ? (
                                <p className="form-error" style={{ color: 'red', fontSize: '14px' }}>{errors.panNo}</p>
                            ) : null} */}
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-md-6 ">
                <div className="form-group">
                  <label
                    htmlFor="inputEmail"
                    className=""
                    style={{ fontSize: "14px" }}
                  >
                    Email:*
                  </label>
                  <input
                    type="email"
                    name="inputEmail"
                    defaultValue={data.cu_email}
                    className="form-control a1"
                    id="inputEmail"
                    // value={values.inputEmail}
                    onChange={handleCustomChange4}
                    onBlur={handleBlur}
                  />
                  {/* {touched.inputEmail && errors.inputEmail ? (
                                <p className="form-error" style={{ color: 'red', fontSize: '14px' }}>{errors.inputEmail}</p>
                            ) : null} */}
                </div>
              </div>
              <div className="col-md-6 ">
                <div className="form-group">
                  <label
                    htmlFor="mobileNo"
                    className=""
                    style={{ fontSize: "14px" }}
                  >
                    Mobile:*
                  </label>
                  <input
                    type="text"
                    name="mobileNo"
                    maxLength={10}
                    defaultValue={data.cu_mobile}
                    className="form-control a1"
                    id="mobileNo"
                    // value={values.mobileNo}
                    onChange={handleCustomChange5}
                    onBlur={handleBlur}
                  />
                  {/* {touched.mobileNo && errors.mobileNo ? (
                                <p className="form-error" style={{ color: 'red', fontSize: '14px' }}>{errors.mobileNo}</p>
                            ) : null} */}
                </div>
              </div>
            </div>

            <div className="row mb-1">
              <div className="col-md-6 ">
                <div className="form-group">
                  <label
                    htmlFor="alterMobNo"
                    className=""
                    style={{ fontSize: "14px" }}
                  >
                    Alternate Mobile No:*
                  </label>
                  <input
                    type="text"
                    name="alterMobNo"
                    defaultValue={data.cu_al_mobile}
                    className="form-control a1"
                    id="alterMobNo"
                    // value={values.alterMobNo}
                    onChange={handleCustomChange6}
                    onBlur={handleBlur}
                  />
                </div>
              </div>
              {/* <div className="col-6 ">
                        <div className="form-group">
                            <label htmlFor="liftType" className='' style={{ fontSize: '14px' }}>Lift Type:*</label>
                            <input type="text" name="liftType" defaultValue={data.cu_lift_type} className="form-control a1" id="liftType"
                                // value={values.liftType}
                                onChange={handleCustomChange7}
                                onBlur={handleBlur} /> */}

              {/* {touched.liftType && errors.liftType ? (
                                <p className="form-error" style={{ color: 'red', fontSize: '14px' }}>{errors.liftType}</p>
                            ) : null} */}
              {/* </div>
                    </div> */}

              <div className="col-md-6 ">
                <div className="form-group">
                  <label
                    htmlFor="typeOfEnquiry"
                    className=""
                    style={{ fontSize: "14px" }}
                  >
                    Type of Enquiry:*
                  </label>
                  <input
                    type="text"
                    name="typeOfEnquiry"
                    maxLength={10}
                    defaultValue={data.cu_lift_type}
                    className="form-control a1"
                    id="typeOfEnquiry"
                    value={typeOfEnquiry}
                    onChange={handleCustomChange7}
                    onBlur={handleBlur}
                  />
                </div>
              </div>

              {/* <div className="col-6 ">
                                <div className="form-group">
                                    <label htmlFor="typeOfEnquiry" className='form-label'style={{fontSize:"14px"}}>Type of Enquiry:*</label>
                                    <div className="dropdown-select">
                                    <select 
                                        name="typeOfEnquiry"
                                        className="form-control a1"
                                        id="typeOfEnquiry"
                                        defaultValue={data.cu_lift_type}
                                        value={typeOfEnquiry}
                                        onChange={handleCustomChange7}
                                        onBlur={handleBlur}
                                    >

                                 
                                    <option value="New Lift">New Lift</option>
                                    <option value="AMC">AMC</option>
                                    <option value="Modulation">Modulation</option>
                                    <option value="Call Base">Call Base</option>
                                    <option value="Manually Typing">Manually Typing</option>
                                  

                                    </select>
                                    <i className="dropdown-icon fas fa-caret-down"></i>
                                </div>
                                    {touched.typeOfEnquiry && errors.typeOfEnquiry ? (
                                        <p className="form-error" style={{ color: 'red', fontSize: '12px' }}>{errors.typeOfEnquiry}</p>
                                    ) : null}
                                </div>
                            </div>  */}
            </div>

            <div className="row mb-1">
              <div className="col-md-6 ">
                <div className="form-group">
                  <label
                    htmlFor="firmName"
                    className=""
                    style={{ fontSize: "14px" }}
                  >
                    Firm Name
                  </label>
                  <input
                    type="text"
                    name="firmName"
                    defaultValue={data.cu_firm}
                    className="form-control a1"
                    id="firmName"
                    // value={values.firmName}
                    onChange={handleCustomChange1}
                    onBlur={handleBlur}
                  />
                </div>
              </div>

              <div className="col-md-6 ">
                <div className="form-group">
                  <label
                    htmlFor="landmark"
                    className=""
                    style={{ fontSize: "14px" }}
                  >
                    Landmark
                  </label>
                  <input
                    type="text"
                    name="landmark"
                    defaultValue={data.cu_landmark}
                    className="form-control a1"
                    id="landmark"
                    // value={values.landmark}
                    onChange={handleLandmark}
                    onBlur={handleBlur}
                  />
                  {/* {touched.landmark && errors.landmark ? (
                                        <p className="form-error" style={{ color: 'red', fontSize: '12px' }}>{errors.landmark}</p>
                                    ) : null} */}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-4">
                <div className="form-group">
                 
                    <img style={{ width: '200px', height: '200px', padding: '10px', borderRadius: '50%' }} className="profile-pic" src={Avatar || values.img} alt="Avatar" /><br />
                    <input  type="file" id="img" name="img" accept="image/*"
                        onChange={handleCustomChange11}
                         />
                </div>
            </div> */}
        </div>

        <div className="row mb-3">
          <div className="col-12 ">
            <div className="form-group">
              <label
                htmlFor="exampleFormControlTextarea1"
                className="form-label"
                style={{ fontSize: "14px" }}
              >
                Address
              </label>
              <textarea
                className="form-control a1"
                defaultValue={data.cu_address}
                name="exampleFormControlTextarea1"
                id="exampleFormControlTextarea1"
                rows="5"
                onChange={handleCustomChange10}
                onBlur={handleBlur}
              ></textarea>
            </div>
          </div>
        </div>

        <div className="container ">
          <div className="row  ">
            <div className="col-12 ">
              <div className="form-group">
                <button
                  onClick={() => editProduct(data.cu_id)}
                  className="btn btn-primary btn-lg float-right"
                  type="submit"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default UpdateCustomer;
